module.exports = function() {
  return new Worker(__webpack_public_path__ + "dec325e38c3e67dfa177.worker.js");
};